import SignupModal from './SignupModal';
import SignupForm from './SignupForm';

export default {
  SignupModal,
  SignupForm,
};
